// extracted by mini-css-extract-plugin
module.exports = {"title":"NewsSignpostTemplate-module--title--1xKuc","list":"NewsSignpostTemplate-module--list--X2gNp"};